




















import 'reflect-metadata'
import { Component, Vue, Prop, Watch, PropSync } from 'vue-property-decorator'

@Component
export default class DropDownFixData extends Vue { 
	@Prop() public changeStateTableItem: any
	@Prop(Object) readonly tableItem: any
	@Prop(String) readonly cloumnName: any
	@Prop() readonly value!: any
  	@Prop() readonly itemData: any
	@Prop(Function) public notifcation: any
	@Prop() public trackid: any
	
	itemValue = null as any

	get modelValue() {
		return this.value
    }

	set modelValue (newValue: any) {
		this.itemValue = newValue
	}

	updateState () {
		this.tableItem[`${this.cloumnName}`] = this.itemValue.id
		this.changeStateTableItem(this.tableItem)
	}

	validate () {
		if (this.cloumnName === "inspection1TypeID") {
			if (this.tableItem.inspection1PlanPJDate === '') {
				this.notifcation('กรุณากรอก Plan PJ พร้อมให้เข้าตรวจ #1', "warning")
				return
			}
		}
	}
}
